import { Reveal } from "@/components/site/motion";
import { GALLERY } from "@/data/content";

const Gallery = () => (
  <section id="facility" className="bg-sand2 py-24 md:py-36 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="grid md:grid-cols-12 gap-8 items-end mb-16">
        <Reveal className="md:col-span-8">
          <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">A Virtual Tour</p>
          <h2 className="font-serif text-4xl md:text-6xl text-forest tracking-tight leading-[1.02]">
            A home, not a hospital — near the Scarborough Bluffs
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-4">
          <p className="text-ink2 leading-relaxed">
            Our residential facility is designed to feel comfortable and safe, so you can focus entirely
            on healing in a calm, natural setting.
          </p>
        </Reveal>
      </div>

      {/* Bento asymmetric grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[180px] md:auto-rows-[220px]">
        {GALLERY.map((g, i) => (
          <Reveal
            key={g.src}
            delay={(i % 4) * 0.08}
            className={
              i === 0 ? "col-span-2 row-span-2" : i === 3 ? "md:col-span-2" : ""
            }
          >
            <div className="group relative w-full h-full rounded-2xl overflow-hidden">
              <img src={g.src} alt={g.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="absolute bottom-4 left-4 text-sand font-serif text-lg opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                {g.label}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
